<script>
	import { ToggleBox, ToggleBoxGrid } from "../../../togglebox";
	import {  BetSettingsLocal } from "../../../../stores";
    import {
        createBetWs
    } from "../../../../scripts/stake-api";

    let props_toggleGrid = {
        cols: 5,
        rows: 5,
        itemSize: "40px",
		borderColor: "#8e8e8e",
		backgroundColor: "#c6c6c6",
		backgroundColorChecked: "#c6c6c6",
		textColor: "#232323",
        textColorChecked: "#3b3b3b",
	};

    let _selectedNumbers 
    let selectedNumbers = [] 
    export {selectedNumbers as selectedFields}

    $: if(_selectedNumbers){  selectedNumbers = [... _selectedNumbers].slice(0, (25 - $BetSettingsLocal.minesCount) ).map( v => parseInt(v)-1).sort((a,b) => a-b) }

    
	$: if(selectedNumbers) { BetSettingsLocal.update({fields: [... selectedNumbers] }) }


    export const placeBet =  async (...args) => {
        try {
             let r = await createBetWs(...args)
            return r
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return {error: e, data: null}
        }
        finally{

        }
    };
</script>
<div class="container">
    <ToggleBoxGrid maxSelectedItems={(25 - $BetSettingsLocal.minesCount)} labeled={false} bind:selectedNumbers={_selectedNumbers} {... props_toggleGrid}></ToggleBoxGrid>	
</div>
<style>
    .container {
        width: fit-content;;
        margin: auto;
        background-color: #fefefe;
    }
</style>
